module.exports = __webpack_public_path__ + "img/15.0b89bde0.webp";